import axios from 'axios'
import {HOST_API} from "../../AppConfig";

export const getMojeZgloszenie = (numer: any, haslo: any) => {
    return axios({
        method: 'GET',
        url: HOST_API + `api/sygnal/byNumer`,
        params: {
            numer: numer,
            pin: haslo
        }
    })
}
